export default __webpack_public_path__ + "static/media/442.bd7160ad.gif";